// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AddRejectionReasonRequestDTO
 */
export interface AddRejectionReasonRequestDTO {
    /**
     * The token used to identify the recipient
     * @type {string}
     * @memberof AddRejectionReasonRequestDTO
     */
    token: string;
    /**
     * The reason for rejecting Reposit
     * @type {string}
     * @memberof AddRejectionReasonRequestDTO
     */
    rejectionReason: AddRejectionReasonRequestDTORejectionReasonEnum;
    /**
     * Custom reason for rejecting Reposit
     * @type {string}
     * @memberof AddRejectionReasonRequestDTO
     */
    customRejectionReason?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AddRejectionReasonRequestDTORejectionReasonEnum {
    NONREFUNDABLEFEE = 'NON_REFUNDABLE_FEE',
    TOOEXPENSIVE = 'TOO_EXPENSIVE',
    DONTUNDERSTAND = 'DONT_UNDERSTAND',
    FAILEDREFERENCING = 'FAILED_REFERENCING',
    OTHER = 'OTHER'
}



